// src/utils/coupon.ts
const COUPON_STORAGE_KEY = 'nwb_coupon';

function parseCodes(raw: string | null): string[] {
  if (!raw) return [];
  return raw
    .split(',')
    .map((c) => c.trim())
    .filter(Boolean)
    .slice(0, 10);
}

// Call on every route change: saves ?coupon= when it's present in the URL.
export function captureCouponFromUrl(): void {
  if (typeof window === 'undefined') return;
  const codes = parseCodes(
    new URLSearchParams(window.location.search).get('coupon')
  );
  if (codes.length) {
    try {
      sessionStorage.setItem(COUPON_STORAGE_KEY, codes.join(','));
    } catch {}
  }
}

// Call at checkout: URL param wins, stored value is the fallback.
export function getCouponCodes(): string[] {
  if (typeof window === 'undefined') return [];
  const fromUrl = parseCodes(
    new URLSearchParams(window.location.search).get('coupon')
  );
  if (fromUrl.length) return fromUrl;
  try {
    return parseCodes(sessionStorage.getItem(COUPON_STORAGE_KEY));
  } catch {
    return [];
  }
}

export function clearStoredCoupon(): void {
  try {
    sessionStorage.removeItem(COUPON_STORAGE_KEY);
  } catch {}
}
